import { DateRangeState, SidebarOption } from './types';
import { addMonths } from 'date-fns';

export const initialDateRangeState: DateRangeState = {
  startDate: null,
  endDate: null,
  hoveredDate: null,
  startDisplayDate: new Date(),
  endDisplayDate: addMonths(new Date(), 1),
  selectedSidebarOption: null, // allowed because DateRangeState uses SidebarOption | null
};

// action types (defined inline so the reducer can use them without importing DateRangeAction)
type SetStartDate = { type: 'SET_START_DATE'; payload: { date: Date | null } };
type SetEndDate = { type: 'SET_END_DATE'; payload: { date: Date | null } };
type SetHoveredDate = { type: 'SET_HOVERED_DATE'; payload: { date: Date | null } };
type SetDisplayDates = {
  type: 'SET_DISPLAY_DATES';
  payload: { startDisplayDate: Date; endDisplayDate: Date };
};
// option can be SidebarOption | null
type SetSelectedSidebarOption = { type: 'SET_SELECTED_SIDEBAR_OPTION'; payload: { option: SidebarOption | null } };

export type DateRangeAction = SetStartDate | SetEndDate | SetHoveredDate | SetDisplayDates | SetSelectedSidebarOption;

// reducer (placement matches original file structure)
export const dateRangeReducer = (state: DateRangeState, action: DateRangeAction): DateRangeState => {
  switch (action.type) {
    case 'SET_START_DATE':
      return {
        ...state,
        startDate: action.payload.date,
      };
    case 'SET_END_DATE':
      return {
        ...state,
        endDate: action.payload.date,
      };
    case 'SET_HOVERED_DATE':
      return {
        ...state,
        hoveredDate: action.payload.date,
      };
    case 'SET_DISPLAY_DATES':
      return {
        ...state,
        startDisplayDate: action.payload.startDisplayDate,
        endDisplayDate: action.payload.endDisplayDate,
      };
    case 'SET_SELECTED_SIDEBAR_OPTION':
      return {
        ...state,
        selectedSidebarOption: action.payload.option,
      };
    default:
      return state;
  }
};
